import {
  Button,
  InputAdornment,
  OutlinedInput,
  useMediaQuery,
} from "@mui/material";
import TopNav from "../components/TopNav";
import splitStyle from "./SplitPage.module.css";
import { MouseEvent, ReactNode, useEffect, useState } from "react";
import { ArrowBack, Search } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

// A list with a detail pane. On computers both show side by side. On phones
// the list fills the screen; tapping an item opens its details full screen
// and "Back" returns to the list.
function SplitPageView({
  contentList,
  mainContent,
  pageTitle,
  breadcrumbs,
  selected,
  search,
  onSearchChange,
}: {
  contentList: ReactNode;
  mainContent: ReactNode;
  breadcrumbs?: ReactNode;
  pageTitle: string;
  // Whether a record is open (for example ?id= is set).
  selected?: boolean;
  search?: string;
  onSearchChange?: (value: string) => void;
}) {
  const isDesktop = useMediaQuery("(min-width: 900px)");
  const location = useLocation();
  const [showDetail, setShowDetail] = useState(!!selected);

  // Links from elsewhere (for example a proposal opened from a customer)
  // land straight on the details.
  useEffect(() => {
    if (selected) {
      setShowDetail(true);
    }
  }, [selected, location.search]);

  // Tapping any link in the list opens the detail view, including "New".
  const openFromList = (e: MouseEvent) => {
    if ((e.target as HTMLElement).closest("a")) {
      setShowDetail(true);
    }
  };

  const list = (
    <div className={splitStyle.listPane}>
      {onSearchChange && (
        <div className={splitStyle.searchBox}>
          <OutlinedInput
            size="small"
            fullWidth
            placeholder={`Search ${pageTitle.toLowerCase()}`}
            value={search || ""}
            onChange={(e) => onSearchChange(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <Search fontSize="small" />
              </InputAdornment>
            }
          />
        </div>
      )}
      <div className={splitStyle.scrollContainer} onClick={openFromList}>
        {contentList}
      </div>
    </div>
  );

  const detail = (
    <div className={splitStyle.viewerContainer}>
      {!isDesktop && (
        <Button
          startIcon={<ArrowBack />}
          onClick={() => setShowDetail(false)}
          className={splitStyle.backButton}
        >
          {pageTitle}
        </Button>
      )}
      {breadcrumbs && isDesktop && (
        <div className={splitStyle.breadcrumbs}>{breadcrumbs}</div>
      )}
      <div className={splitStyle.viewer}>{mainContent}</div>
    </div>
  );

  return (
    <div className={`page ${splitStyle.page}`}>
      <TopNav pageTitle={pageTitle} />
      <main className={splitStyle.split}>
        {isDesktop ? (
          <>
            {list}
            {detail}
          </>
        ) : showDetail ? (
          detail
        ) : (
          list
        )}
      </main>
    </div>
  );
}

export default SplitPageView;
